import { ResolveFn } from '@angular/router';
import { inject, Injector } from '@angular/core';
import { Store } from '@softline/core';
import { handleRequestError } from '@softline/application';
import { SOFTLINE_FEATURE_DELIVERY_NOTE } from '../delivery-note.shared';
import { DeliveryNotesStore } from '../stores';

export const deliveryNoteResolver: ResolveFn<void> = async (route) => {
  const store = inject(Store);
  const injector = inject(Injector);
  const id = route.paramMap.get('id');
  if (!id) return;
  try {
    await store.dispatch(
      SOFTLINE_FEATURE_DELIVERY_NOTE,
      DeliveryNotesStore.actions.collection.loadOnce,
      { id: +id }
    );
  } catch (e) {
    handleRequestError(e, injector, { show: true });
  }
};
